const run_vars = window.APP_CONFIG || {};

export const hostServer = run_vars.API_URL || "http://localhost:8000";
export const dashboardUrl = run_vars.DASHBOARD_URL || "http://localhost:3000";
// https://api.updamus.com/api
// http://192.168.1.144:8070
// http://185.213.165.14:60080
// https://api.up.hamravesh.ir
